import AtomicDashboard from "../../../../src/courses/partials/atomic/dashboard.mdx";
import * as React from 'react';
export default {
  AtomicDashboard,
  React
};